<div mat-dialog-title class="flex flex-row justify-between items-baseline">
  @if (passwordExpired) {
    <span> Password Expired </span>
  }
  @if (!passwordExpired) {
    <span> Change your password</span>
  }
  <button [mat-dialog-close]="false" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (passwordExpired) {
    <p class="text-gray-600">
      Your password has expired and you need to set a new one. <br />An email has been sent with the 6-digit
      Verification Code that you need to enter in the following form:
    </p>
  }
  <div class="box-container">
    <form novalidate [formGroup]="changePasswordForm" autocomplete="off" class="flex flex-col">
      <div class="user-name">
        <span class="user-name-label">User Name</span>
        <p>{{ userName }}</p>
      </div>

      <mat-form-field color="accent" class="full-width">
        <mat-label>6-digit Verification Code</mat-label>
        <input
          matInput
          formControlName="confirmationCode"
          mask="000000"
          placeholder="6-digit Verification Code"
          required />
        @if (confirmationCode.invalid && (confirmationCode.dirty || confirmationCode.touched)) {
          <mat-error>
            @if (confirmationCode.errors?.required || confirmationCode.errors?.mask) {
              <span> 6-digit Verification Code is required </span>
            }
          </mat-error>
        }
      </mat-form-field>
    </form>
    <mepco-password-strength
      #passwordStrengthComponent
      [min]="passwordPolicies.minimumLength"
      [max]="30"
      [enableDigitRule]="passwordPolicies.requireNumbers"
      [enableLowerCaseLetterRule]="passwordPolicies.requireLowercase"
      [enableUpperCaseLetterRule]="passwordPolicies.requireUppercase"
      [enableSpecialCharRule]="passwordPolicies.requireSymbols"
      (passwordStrengthForm)="getFormValues($event)">
    </mepco-password-strength>
  </div>

  <mat-dialog-actions class="flex flex-row justify-end">
    <button
      mat-raised-button
      type="submit"
      color="primary"
      [disabled]="changePasswordForm.invalid || !passwordStrengthForm().valid"
      (click)="onSave()">
      Change Password
    </button>
    <button mat-raised-button type="button" style="margin-left: 10px" (click)="onResendConfirmationCode()">
      Resend Code
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
